import type { Address, Connector } from '../facade/facadeApiV3';
import { type Waypoint, WaypointType } from './searchSlice';
import type { Coords } from '../../common/types';

export class WaypointBuilder {
    private readonly waypoint: Waypoint;

    constructor() {
        this.waypoint = {
            id: 0,
            address: null,
            addressLabel: '',
            type: WaypointType.ADDITIONAL_STOP,
            timeAtStopover: null,
            cargoAtDeparture: null,
            isInRange: null,
            extended: false,
        };
    }

    public withId(id: number): this {
        this.waypoint.id = id;
        return this;
    }

    public withAddress(address: Address): this {
        this.waypoint.address = address;
        return this;
    }

    public withAddressLabel(addressLabel: string): this {
        this.waypoint.addressLabel = addressLabel;
        return this;
    }

    public withCoordinates(coordinates: Coords): this {
        this.waypoint.coordinates = coordinates;
        return this;
    }

    public withType(type: WaypointType): this {
        this.waypoint.type = type;
        return this;
    }

    public withConnectors(connectors: Connector[]): this {
        this.waypoint.connectors = connectors;
        return this;
    }

    public withMaxPower(max_power: number): this {
        this.waypoint.maxPower = max_power;
        return this;
    }

    public withVoltage(voltage: number): this {
        this.waypoint.voltage = voltage;
        return this;
    }

    public withCurrent(current: number): this {
        this.waypoint.current = current;
        return this;
    }

    public withStationId(station_id: string): this {
        this.waypoint.station_id = station_id;
        return this;
    }

    public withTimeAtStopover(timeAtStopover: string): this {
        this.waypoint.timeAtStopover = timeAtStopover;
        return this;
    }

    public withCargoAtDeparture(cargoAtDeparture: number): this {
        this.waypoint.cargoAtDeparture = cargoAtDeparture;
        return this;
    }

    public withIsInRange(isInRange: boolean): this {
        this.waypoint.isInRange = isInRange;
        return this;
    }

    public withExtended(extended: boolean): this {
        this.waypoint.extended = extended;
        return this;
    }

    public build(): Waypoint {
        return this.waypoint;
    }
}
